import InterviewCancelledReason from "@/models/JobWorkerInterviews/InterviewCancelledReason";

export default (value: InterviewCancelledReason) => {
    switch (value) {
        case InterviewCancelledReason.CreatedByMistake:
            return "Created by mistake";
        case InterviewCancelledReason.ContactUnavailable:
            return "Contact unavailable";
        case InterviewCancelledReason.ContactNoLongerInterested:
            return "Contact no longer interested";
        case InterviewCancelledReason.WorkerUnavailable:
            return "Worker unavailable";
        case InterviewCancelledReason.WorkerNoLongerInterested:
            return "Worker no longer interested";
        default:
            return "Unknown";
    }
} 